import { views } from './views';

// TODO: peace of sh
export const defaultEnvironmentType = views.find((data) => data.checked)?.value ?? views[0].value;
export const environmentTypeOptions = {
  en: [...views.map((data) => ({
    value: data.value,
    label: data.name.en,
  })), { value: 'custom', label: 'My custom view', isSpecial: true }],
  ru: views.map((data) => ({
    value: data.value,
    label: data.name.ru,
  })),
};
